import { render, staticRenderFns } from "./HomeDeleteApproval.vue?vue&type=template&id=dc04d638"
import script from "./HomeDeleteApproval.vue?vue&type=script&lang=js"
export * from "./HomeDeleteApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports